import React  from 'react';
import LogoGPPColoredUrl from 'assets/logos/gpp.svg';
import LogoGPPWhiteUrl from 'assets/logos/gpp-white.svg';
import LogoGDPColoredUrl from 'assets/logos/gdp.svg';
import LogoGDPWhiteUrl from 'assets/logos/gdp-white.svg';
import { ReactComponent as LogoSphacy } from 'assets/logos/logo-sphacy.svg';
import { APP_BRANCH, APP_BRANCH_GDP } from 'utils/util';

const Logo = ({ type = 'colored', ...props }) => {
  if (APP_BRANCH === APP_BRANCH_GDP) {
    const src = type === 'white' ? LogoGDPWhiteUrl : LogoGDPColoredUrl;
    return <img src={src} alt="Logo GDP" {...props} />;
  }
  const src = type === 'white' ? LogoGPPWhiteUrl : LogoGPPColoredUrl;
  return <img src={src} alt="Logo GPP" {...props} />;
};

export default Logo;
